module.exports = __webpack_public_path__ + "img/img_block_1.3d22b0fc.png";